// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.status[data-v-2f600c0f] {\n  padding: 5px 10px;\n  border-radius: 5px;\n  width: 150px;\n  text-align: center;\n}\n.hint[data-v-2f600c0f] {\n  font-size: 0.8em;\n}\n", ""]);
// Exports
module.exports = exports;
